export default __webpack_public_path__ + "static/media/BG-Red-0002.f3c1d67a.png";